import { IContractsResponse } from '@/api/contract/type'
import { FC } from 'react'
import Letterhead from './Letterhead'

export type PageProps = {
  data?: IContractsResponse
}

const placeholder = (value?: string | null) => value?.trim() || '-----------'

const Page1: FC<PageProps> = ({ data }) => {
  const fullName = placeholder(
    [data?.first_name, data?.last_name].filter(Boolean).join(' ')
  )
  const businessName = placeholder(
    data?.is_individual
      ? data.individual_info?.market_name
      : data?.legal_info?.market_name
  )

  return (
    <Letterhead data={data} pageNumber={1}>
      <h1 className="text-lg font-bold">ماده ۱)</h1>
      <h1 className="mb-2 text-lg font-bold">طرفین قرارداد</h1>
      <p className="text">
      این قرارداد بین نوآوران کسب و کار آسان به شماره ثبت 672152، شناسه ملی
        14015309670 به نمایندگی آقای رضا قنبرزاده میاندهی به سمت رئیس هیأت مدیره
        و آقای حسین نجفی زیارانی به سمت مدیرعامل و به اقامتگاه قانونی مرکز اصلي
        : استان تهران، شهرستان تهران، بخش مرکزی، شهر تهران، دریان نو، خیابان
        خسروان، خیابان شهید دکتر حبیب الله، پلاک 56، ساختمان ایستگاه نوآوری شریف،
        طبقه همکف کدپستی 1455714181 که از این پس «آپولون» نامیده می‌شود از یکطرف و{' '}
        <span className="font-bold">{fullName}</span> به شماره ملی{' '}
        <span className="font-bold">
          {placeholder(data?.national_code)}
        </span>{' '}
        و به نشانی: <span className="font-bold">{placeholder(data?.company_address as string)}</span>{' '}
        و کد پستی :{' '}
        <span className="font-bold">{placeholder(data?.postal_code)}</span>{' '}
        دارنده فروشگاه با نام تجاری{' '}
        <span className="font-bold">{businessName}</span> و سایت اینترنتی{' '}
        <span className="font-bold">{placeholder(data?.individual_info?.website_address as string)}</span> که از این‌ پس «پذیرنده»{' '}
        نامیده می‌شود از طرف دیگر، به شرح مفاد زیر منعقد گردید.
      </p>
      <br />
      <p className="text">
        تبصره ۱: در صورت واگذاری مالکیت فروشگاه پذیرنده به هر نحو (اعم از اجاره،
        بیع، صلح و غیره) به شخص ثالث، منتقل الیه قائم مقام قانونی پذیرنده تلقی و
        کلیه تعهدات این قرارداد متضامناً متوجه او نیز می گردد.
      </p>
      <p className="text">
        تبصره ۲: آدرس اعلامی طرفین بر اساس ماده ۱۰۱۰ قانون مدنی، اقامتگاه قانونی
        و قراردادی طرفین محسوب شده و تمامی مکاتبات مرتبط با این قرارداد بر اساس
        این آدرس صورت خواهد گرفت. در صورت تغییر آدرس طرفین موظف هستند این تغییر
        را در اسرع وقت به صورت کتبی به طرف مقابل اعلام نمایند.
      </p>
      <p className="text">
        تبصره ۳: کلیه مکاتبات الکترونیکی با پذیرنده از طریق آدرس ایمیل پذیرنده
        به نشانی <span className="font-bold">{placeholder(data?.email)}</span>{' '}
        انجام خواهد شد.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۲)</p>
      <p className="mb-2 text-lg font-bold">تعاریف</p>
      <p className="text">
        شبکه پذیرندگان اعتباری آپولون: عبارت است از کلیه فروشگاه‌ها، برندها،
        سازمان‌ها و شرکت‌هایی که امکان خرید اعتباری کاربران آپولون برای آنها
        فراهم و فعال شده است.
      </p>
      <p className="text">
        سرویس اعتباری آپولون: سرویسی است که کاربران سوپراپلیکیشن آپ به واسطه‌ی
        آن می‌توانند خدمات، کالاها و سرویس‌های شبکه‌ی پذیرندگان اعتباری آپولون
        را به‌صورت اعتباری، اقساطی، اعتبار سازمانی، بن کارت، پرداخت مستقیم و کیف
        پول خرید کنند.
      </p>
      <p className="text">
        خرید اعتباری: عبارت است از خرید از شبکه‌ی پذیرندگان آپولون از طریق
        سرویس اعتباری آپولون. در این نوع خرید، کاربر به پذیرنده مبلغی پرداخت
        نمی‌کند و مجموع مبالغ خرید کاربران توسط آپولون و ظرف مدت زمان مشخص شده
        با پذیرنده تسویه می‌شود.
      </p>
      <p className="text">
        کاربران آپولون: عبارت است از کلیه کاربران سوپر اپلیکیشن آپ، که امکان
        خرید با سرویس اعتباری برای آنها فراهم شده است.
      </p>
      <p className="text">
        تاریخ خرید: عبارت از تاریخی است که کاربران آپولون در آن تاریخ از طریق
        سرویس اعتباری آپولون، از پذیرنده خرید کرده اند.
      </p>
      <p className="text">
        درگاه پرداخت اعتباری آپولون: عبارت است از کلیه درگاه‌های ارائه شده توسط
        آپولون به پذیرنده که مشتری به واسطه ی آنها خرید اعتباری خود را انجام
        می‌دهد. این درگاه‌ها شامل درگاه خرید اینترنتی و فیزیکی (شامل پوز، کیوآر
        کد، بارکدخوان و...) می‌باشد.
      </p>
      <p className="text">
        کالا یا خدمات: عبارت است از کالاها یا خدمات ارائه شده توسط پذیرنده به
        کاربران. در صورتی که در این قرارداد محدودیتی برای این مورد ذکر نشود،
        تمامی کالاها و خدمات ارائه شده توسط پذیرنده به کاربران را شامل می‌شود.
      </p>
      <br />
      <p className="text-lg font-bold">ماده ۳)</p>
      <p className="mb-2 text-lg font-bold">موضوع قرارداد</p>
      <p className="text">
        موضوع قرارداد عبارت است از اضافه کردن پذیرنده به شبکه‌ی پذیرندگان
        اعتباری آپولون، به منظور فراهم کردن امکان خرید اعتباری از پذیرنده برای
        کاربران آپولون.
      </p>
      <br />
      <p className="text">
        تبصره ۴: امضا کنندگان این قرارداد اقرار می‌نمایند که اختیار و صلاحیت
        لازم به منظور امضای این قرارداد را داشته و در صورت فساد اقرار، امضا
        کننده شخصاً مسئول اجرای تعهدات قراردادی و هرگونه خسارات ناشی از نقض
        قرارداد یا بی‌اعتباری آن خواهد بود. بند حاضر به عنوان یک تعهد مستقل در
        هر حال حتی در فرض بی‌اعتباری قرارداد معتبر و لازم‌الاجرا می‌باشد.
      </p>
    </Letterhead>
  )
}

export default Page1
